import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Arrow } from 'src/assets';

import { ReactComponent as DoubleArrow } from 'src/assets/overall/DoubleArrow.svg';

import './customPagination.scss';

export const CustomPagination = (props) => {
  const {
    totalItems = 0,
    initialPage = 1,
    initialPerPage = 10,
    onPageChange,
    withSelect = true,
  } = props;

  const { t } = useTranslation('title');

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [perPage, setPerPage] = useState(initialPerPage);
  const [isPerPageDropdownOpen, setIsPerPageDropdownOpen] = useState(false);

  const perPageOptions = [1, 3, 5, 10, 20];
  const totalPages = Math.max(Math.ceil(totalItems / perPage), 0);

  useEffect(() => {
    setCurrentPage(initialPage);
  }, [initialPage]);

  useEffect(() => {
    setPerPage(initialPerPage);
  }, [initialPerPage]);

  const handlePageChange = (page) => () => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    if (onPageChange) onPageChange(page, perPage);
  };

  const handlePerPageChange = (newPerPage) => () => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    setIsPerPageDropdownOpen(false);
    if (onPageChange) onPageChange(1, newPerPage);
  };

  const togglePerPageDropdown = () => setIsPerPageDropdownOpen(!isPerPageDropdownOpen);

  const renderPageNumbers = () => {
    if (totalPages <= 1) {
      return [];
    }

    const pages = [];

    pages.push(1);

    if (currentPage > 4) {
      pages.push('...');
    }

    const startPage = Math.max(2, currentPage - 2);
    const endPage = Math.min(totalPages - 1, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      if (!pages.includes(i)) {
        pages.push(i);
      }
    }

    if (currentPage < totalPages - 3) {
      pages.push('...');
    }

    pages.push(totalPages);

    return pages;
  };

  return (
    <div className="pagination">
      {totalPages > 1 && (
        <>
          <button
            type="button"
            onClick={handlePageChange(1)}
            disabled={currentPage === 1}
            className="pagination-btn-double-arrow"
          >
            <DoubleArrow style={{ transform: 'rotate(-180deg)' }} />
            {/* <img src={DoubleArrow} alt="First Page" style={{ transform: 'rotate(-180deg)' }} /> */}
          </button>
          <button
            type="button"
            onClick={handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            <img
              src={Arrow}
              alt="Previous Page"
              style={{ transform: 'rotate(-180deg)', marginRight: '5px' }}
            />
            {t('previous')}
          </button>
        </>
      )}

      {renderPageNumbers().map((page, index) =>
        page === '...' ? (
          <span key={`ellipsis-${index}`} className="pagination-ellipsis">
            {page}
          </span>
        ) : (
          <button
            type="button"
            key={`page-${page}`}
            onClick={handlePageChange(page)}
            className={`pagination-btn-number ${currentPage === page ? 'active' : ''}`}
          >
            {page}
          </button>
        ),
      )}

      {totalPages > 1 && (
        <>
          <button
            type="button"
            onClick={handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            {t('next')}
            <img src={Arrow} alt="Next Page" style={{ marginLeft: '5px' }} />
          </button>
          <button
            type="button"
            onClick={handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="pagination-btn-double-arrow"
          >
            <DoubleArrow />
            {/* <img src={DoubleArrow} alt="Last Page" /> */}
          </button>
        </>
      )}

      {withSelect ? (
        <div className="pagination-dropdown per-page-dropdown">
          <button type="button" onClick={togglePerPageDropdown} className="dropdown-btn">
            {perPage}
          </button>
          {isPerPageDropdownOpen && (
            <div className="dropdown-menu">
              {perPageOptions.map((count) => (
                <div
                  key={`perPage-${count}`}
                  className={`dropdown-item ${perPage === count ? 'active' : ''}`}
                  onClick={handlePerPageChange(count)}
                >
                  {count}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};
